import { projectionField } from "./projectionSource";
import { buildDraftValues } from "./draftValuesBridge";
import { DEFAULT_SETTINGS } from "../data/scoring";
import { isQbPremiumFormat } from "./leagueFormat";

// Mock1 Value: the same VORP dollars ProjectionLab's "Build Draft Values" writes,
// built on demand from the live field (user Lab saves > house set > market curve)
// under the CURRENT league settings, so every user sees a value column without
// visiting the Lab. Mirrors ProjectionLab.handleBuildValues exactly — keep the
// two in step. Display-only; nothing in src/engine or usePricing may import it.
export const AUTO_VALUE_SOURCE = "auto";

export function buildAutoDraftValues({ settings, league }) {
  const positions = settings?.positions ?? DEFAULT_SETTINGS.positions;
  const bridgeSettings = {
    teams: settings?.teams ?? DEFAULT_SETTINGS.teams,
    budget: settings?.budget ?? DEFAULT_SETTINGS.budget,
    positions,
    scoring: settings?.scoring ?? DEFAULT_SETTINGS.scoring,
  };
  // QB-premium effective replacement is waiver-tier, so bench demand is ON there
  // — same rule handleBuildValues applies; single-QB keeps starters-only
  // replacement, validated against Smithtown 2022-25 prices.
  const { values, meta } = buildDraftValues(projectionField(), bridgeSettings, {
    benchDemand: isQbPremiumFormat(positions),
  });
  return {
    builtAt: new Date().toISOString(),
    league: league ?? null,
    teams: meta.teams,
    budget: meta.budget,
    scoringLabel: meta.scoringLabel,
    values,
    source: AUTO_VALUE_SOURCE,
  };
}
